import getPublicEnv from '@utils/getPublicEnv';
const IsShopMiddleware = ({
  children
}) => {
  const isServerSide = typeof window === 'undefined';
  const isShop = isServerSide ? process.env.IS_SHOP : getPublicEnv('NEXT_PUBLIC_IS_SHOP');
  return isShop === 'true' ? <>{children}</> : <></>;
};
export default IsShopMiddleware;